<template>
  <div class="order-ins">
    <img class="order-image" :src="cdnresources + '/uat/images/xiangaibao/order-banner.png'" />
    <img class="order-image middle" :src="cdnresources + '/uat/images/xiangaibao/order-supply.png'" />
    <img class="order-image" :src="cdnresources + '/uat/images/xiangaibao/whos.png'" />
    <div class="btnBox">
      <div class="orderBtn" @click="showInsForm = true">立即预约参保</div>
    </div>
    <van-popup v-model="showInsForm" closeable position="bottom">
      <div class="order-ins-form">
        <div class="order-ins-form-title">
          <img class="title-img" src="../../assets/img/insu_detail/title-left.png" alt="">
          <span class="title-text">请输入手机号完成预约</span>
          <img class="title-img" src="../../assets/img/insu_detail/title-left.png" alt="">
        </div>
        <div>
          <van-form :show-error-message='false' ref="form">
            <van-field
              v-model="form.mobile"
              name="手机号"
              label=""
              placeholder="请输入手机号码"
              :rules="formRules.mobile"
              ref="mobile"
              @focus="onFocus('mobile')"
            />
            <van-field
              v-model="form.captcha"
              name="验证码"
              label=""
              ref="captcha"
              placeholder="请填写验证码"
              @focus="onFocus('captcha')"
              :rules="[{ required: true, message: '请填写验证码' }]">
              <template #button>
                <van-button class="codeBtn" size="small" @click="getCode">{{veriTipText}}</van-button>
              </template>
            </van-field>
            <div class="check-part">
              <van-checkbox v-model="checked"
                shape="square"
                checked-color="#4B8DFA"
                icon-size="13px"/>
              <div class="agreen">
                我已阅读并同意
                <a @click.stop="showzhuchexieyi = true">「用户协议」</a>
                <a @click.stop="showyisixiey = true">「隐私声明」</a>
              </div>
            </div>
          </van-form>
          <div class="submitBox">
            <div class="submitBtn" @click="onSubmit">立即预约参保</div>
          </div>
        </div>
      </div>
    </van-popup>
    <pdf-action-sheet v-model="showzhuchexieyi" :style-obj="{ height: '70%' }"  title="用户协议">
      <RegisterProtocol />
    </pdf-action-sheet>
    <pdf-action-sheet v-model="showyisixiey" :style-obj="{ height: '70%' }"  title="隐私声明">
      <PrivacyStatement />
    </pdf-action-sheet>
  </div>
</template>
<script>
import { CHECK_MOBILE_PHONE } from '@/util/validate'
import { Toast, Notify } from 'vant'
import { GetVerificationCode } from '@/api/user'
import { submitOrder } from "@/api/orderIns"
import { cdnresources } from '@/util/config'
import RegisterProtocol from '@/views/UserSection/RegisterProtocol'
import PrivacyStatement from '@/views/UserSection/PrivacyStatement'
import PdfActionSheet from '@/views/PdfFiles/PdfActionSheet'
export default {
  components:{
    PrivacyStatement,
    PdfActionSheet,
    RegisterProtocol
  },
  data(){
    return {
      cdnresources,
      form:{
        mobile:'',captcha:''
      },
      formRules:{
        mobile: [
          { required: true},
          {
            validator: this.mobileNumberValidator,
            message: '手机号格式不正确'
          }
        ],
      },
      checked:false,
      veriTipText:'获取验证码',
      showyisixiey:false,
      showzhuchexieyi:false,
      showInsForm:false
    }
  },
  methods:{
    mobileNumberValidator(val) {
      return CHECK_MOBILE_PHONE(val)
    },
    async getCode(){
      if(this.form.mobile===''){
        Toast('请填写手机号')
        return false
      }
      if( !CHECK_MOBILE_PHONE(this.form.mobile)){
        Toast('请填写正确手机号')
        return false 
      }
      
      if(this.veriTipText ==='120s后重新获取' || this.veriTipText ==='获取验证码'){
        await GetVerificationCode({
          mobilePhone: this.form.mobile
        })
        this.showKeyboard = false
        this.veriTipText = '120s后重新获取'
        let num = 120
        this.veriInterval = setInterval(() => {
          num--
          if (num > 0) {
          
            this.veriTipText = num + 's后重新获取'
          } else {
            clearInterval(this.veriInterval)
            this.veriTipText = '获取验证码'
            this.veriInterval = null
            this.isGettingVeriCode = false
          }
        }, 1000)
      }
    },
    onFocus(e){
      this.$refs[e].resetValidation()
    },
    onSubmit(){
      if(!this.checked){
        Notify('请认真阅读底部协议并勾选');
        return
      }
      this.$refs.form.validate().then(async ()=>{
        let data = await submitOrder(this.form)
        if(data === '已经存在预约信息'){
          Toast(data)
        }else{
          this.$router.push({name:'OrderSuccess'})
        }
      }).catch((err)=>{
        console.log(err)
      })
    }
  }
}
</script>
<style lang="scss">
  .order-ins{
    background: #F2F2F2;
    padding-bottom: xvw(180);
    .order-image{
      width: 100%;
    }
    .middle{
      margin-top: xvw(20);
    }
    .order-ins-form{
      background: #ffffff;
      padding: xvw(30) 0 xvw(80);
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      .order-ins-form-title{
        display: flex;
        justify-content: center;
        align-items: center;
        padding: xvw(40) 0;
        .title-img{
          width: xvw(62);
        }
        // .title-text{
        //   font-size: xvw(36);
        //   font-weight: 600;
        //   color: #4F4F4F;
        //   line-height: xvw(50);
        //   letter-spacing: xvw(1);
        //   margin: xvw(70) xvw(19) xvw(70);
        // }
      }
      .van-form{
        display: flex;
        flex-direction: column;
        align-items: center;
        .codeBtn{
          background: #F2F2F2;
          border: 0;
          color: #4385FC;
          font-weight: 400;
          font-size: xvw(28);
        }
        .van-field{
          width: xvw(648);
          height: xvw(108);
          background: #F2F2F2;
          border-radius: xvw(16);
          margin-bottom: xvw(21);
          display: flex;
          justify-content: space-between;
          align-items: center;
          padding: 0 xvw(40);
          font-size: xvw(32);
        }
      }
      .check-part{
        width: 100%;
        display: flex;
        font-size: xvw(24);
        justify-content: flex-start;
        align-items: center;
        margin-bottom: xvw(20);
        .van-checkbox{
          margin: 0 xvw(30) 0 xvw(33);
        }
        .agreen{
          a{
            color: #4385FC;
          }
        }
      }
    }
    .btnBox{
      width: 100%;
      border-radius: xvw(15);
      display: flex;
      justify-content: center;
      padding: xvw(40) 0;
      background: #ffffff;
      position: fixed;
      bottom: xvw(0);
      .orderBtn{
        width: xvw(670);
        height: xvw(88);
        background: linear-gradient(90deg, #FFAF40 0%, #FF7108 100%);
        border-radius: xvw(55);
        line-height: xvw(88);
        text-align: center;
        color: #ffffff;
        padding: xvw(20) auto xvw(42);
        
      }
      
    }
    .submitBox{
      width: 100%;
      display: flex;
      justify-content: center;
      padding: xvw(40) 0;
      background: #ffffff;
      .submitBtn{
        width: xvw(670);
        height: xvw(88);
        background: linear-gradient(90deg, #FFAF40 0%, #FF7108 100%);
        border-radius: xvw(55);
        line-height: xvw(88);
        text-align: center;
        color: #ffffff;
        padding: xvw(20) auto xvw(42);
      }
    }
    input:-webkit-autofill,
    input:-webkit-autofill:hover,
    input:-webkit-autofill:focus,
    input:-webkit-autofill:active {
        -webkit-transition-delay: 111111s;
        -webkit-transition: color 11111s ease-out, background-color 111111s ease-out;
    }
  }
</style>